/**
 * About page copy. Facts only — no invented numbers. Founded 2023. Project
 * count and team members are still to come from the owner.
 */

/** The layers of the stack, bottom → top (drawn on the About hero). */
export const STACK_LAYERS = [
  { name: "Strategy", note: "Research & planning" },
  { name: "Design", note: "UX / UI" },
  { name: "Engineering", note: "Web & mobile" },
  { name: "Quality", note: "QA & testing" },
  { name: "Cloud", note: "DevOps & security" },
  { name: "Growth", note: "Marketing & support" },
];

/** Big-number facts. Keep them true. */
export const ABOUT_FACTS = [
  { value: "2023", label: "Founded in Kitchener, Ontario" },
  { value: "7", label: "Services under one roof" },
  { value: "4", label: "Industries we’ve built for" },
  { value: "1", label: "Team accountable for all of it" },
];

export const ABOUT_BELIEFS = [
  {
    eyebrow: "What we believe",
    title: "Good software comes from one team that owns the outcome.",
    text: "When design, engineering and operations sit with different vendors, every hand-off loses context. We keep them together, so decisions are faster, accountability is clear and nothing falls through the cracks.",
  },
  {
    eyebrow: "How we work with you",
    title: "Partners, not order-takers.",
    text: "We ask hard questions early, push back when something won’t serve your users, and keep you informed at every step. You’ll always know where your project stands.",
  },
];

export const PRINCIPLES = [
  { title: "Be transparent", text: "Clear scope, honest updates, no surprises." },
  { title: "Plan first", text: "An hour of planning saves a week of rework." },
  { title: "Ship with care", text: "Speed matters — never at the cost of quality." },
  { title: "Start from the problem", text: "No templates. Every solution begins with what you actually need." },
];
